import { render, staticRenderFns } from "./DeviceUploads.vue?vue&type=template&id=e79fc5b8&"
import script from "./DeviceUploads.vue?vue&type=script&lang=js&"
export * from "./DeviceUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports